import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { CHANGE_SURVEY_STATUS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { PublishSurveyDataActionTypes } from './types';
import api from 'src/utils/api';
import { allListSurveyPublish } from '../allSurvey/actions';

export const loadChangeSurveyStatus =
  (
    id: number,
    status: number,
  ): ThunkAction<Promise<void>, State, null, PublishSurveyDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: CHANGE_SURVEY_STATUS + REQUEST });
    try {
      const payload = await api.loadPublishSurvey(id, { status });
      dispatch({ type: CHANGE_SURVEY_STATUS + SUCCESS, payload });
      dispatch(allListSurveyPublish(id, status));
    } catch (error) {
      dispatch({ type: CHANGE_SURVEY_STATUS + FAILURE, error });
    }
  };

export const changeStatusSurveyIdle = () => ({
  type: CHANGE_SURVEY_STATUS + IDLE,
});
